import { IKCore } from 'imagekitio-react'
import { IMAGEKIT_PUBLIC_KEY, IMAGEKIT_URL_ENDPOINT } from '~/src/lib/constants'

const imagekit = new IKCore({
  publicKey: IMAGEKIT_PUBLIC_KEY,
  urlEndpoint: IMAGEKIT_URL_ENDPOINT,
})

const useImageKit = (): IKCore => {
  return imagekit
}

export default useImageKit
